import PhotoPlaceholder from './photo-placeholder';
import { TESTIMONIOS } from '../data/content';
import { SHOW_TESTIMONIOS } from '../lib/business';
import { eyebrow } from '../lib/styles';

// Off by default (SHOW_TESTIMONIOS) -- only turn on once real client
// screenshots/videos exist. Renders on Inicio and Contacto when enabled.
const Testimonials = () => {
  if (!SHOW_TESTIMONIOS) return null;

  return (
    <section style={{ background: '#FFF', borderTop: '1px solid var(--ink-100)', padding: '5vw' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <span style={eyebrow}>Testimonios</span>
        <h2
          style={{
            fontFamily: 'var(--font-display)',
            fontWeight: 300,
            fontSize: 'clamp(28px, 4vw, 42px)',
            color: 'var(--ink-900)',
            margin: '14px 0 10px',
          }}
        >
          Lo que dicen nuestras clientas
        </h2>
        <p style={{ fontSize: 14, color: 'var(--ink-500)', margin: '0 0 3vw', maxWidth: '64ch' }}>
          Sección desactivada por defecto. Se activa cuando existan capturas y videos reales de clientas; no se redactan
          reseñas.
        </p>
        <div
          style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 220px), 1fr))', gap: 18 }}
        >
          {TESTIMONIOS.map((t) => (
            <PhotoPlaceholder key={t.label} eyebrowText={t.tipo} label={t.label} ratio={t.ratio} tone="ink" />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
